import {
  Route,
  Routes,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';
import { useGetMedicalProvidersQuery } from '@/services/api/treatmentService';

import { EditCheckInPage } from './check-ins/edit';
import { TreatmentCheckInDetailsPage } from './check-ins/TreatmentCheckInDetailsPage';
import { TreatmentCheckInsPage } from './check-ins/TreatmentCheckInsPage';
import { CheckInV2DetailView } from './check-ins-v2/CheckInV2DetailView';
import { CheckInV2View } from './check-ins-v2/CheckInV2View';
import { CreateProviderPageV2 } from './medical-provider/CreateProviderPageV2';
import { EditProviderPage } from './medical-provider/EditProviderPage';
import { MedicalProviderDetails } from './medical-provider-details/MedicalProviderDetails';
import { MergeProvidersPage } from './medical-provider-merge/MergeProvidersPage';
import { TreatmentTimeline } from './treatment-timeline/TreatmentTimeline';
import { TreatmentOverviewPage } from './TreatmentLayoutPage';
import { TreatmentOverview } from './TreatmentOverviewPage';

const ProviderDetailsWrapper = () => {
  const { matterId } = useMatter();
  const { provider_id } = useParams<{ provider_id: string }>();
  const navigate = useNavigate();

  if (!provider_id) {
    return null;
  }

  return (
    <MedicalProviderDetails
      matterId={matterId}
      providerId={provider_id}
      onBack={() => navigate(`/matters/${matterId}/treatment`)}
      backButtonText="Back to Providers"
    />
  );
};

const TimelineContent = () => {
  const { matterId } = useMatter();
  const navigate = useNavigate();
  const {
    data: providers,
    isLoading,
    error,
  } = useGetMedicalProvidersQuery(matterId);

  const handleProviderSelect = (providerId: string) => {
    navigate(`/matters/${matterId}/treatment/${providerId}`);
  };

  return (
    <TreatmentTimeline
      matterId={matterId}
      providers={providers || []}
      isLoading={isLoading}
      error={error}
      onProviderSelect={handleProviderSelect}
    />
  );
};

export const TreatmentRoutes = () => {
  const { matterId } = useMatter();

  return (
    <Routes>
      <Route path="/" element={<TreatmentOverviewPage />}>
        <Route index element={<TreatmentOverview />} />
        <Route path="overview" element={<TreatmentOverview />} />
        <Route path="timeline" element={<TimelineContent />} />
        <Route
          path="check-ins"
          element={<TreatmentCheckInsPage matterId={matterId} />}
        />
      </Route>

      <Route path="/create" element={<CreateProviderPageV2 />} />
      <Route path="/merge" element={<MergeProvidersPage />} />
      <Route path="/:provider_id" element={<ProviderDetailsWrapper />} />
      <Route path="/:provider_id/edit" element={<EditProviderPage />} />
      <Route
        path="/check-ins/:check_in_id"
        element={<TreatmentCheckInDetailsPage matterId={matterId} />}
      />

      <Route
        path="/check-ins/:check_in_id/edit"
        element={<EditCheckInPage />}
      />

      {/* Check-In V2 operator view. Matter permissions are enforced by the
          backend, and Smart Check-in is available anywhere the user can access
          the matter. */}
      <Route
        path="/check-in-v2/:checkInId"
        element={<CheckInV2View />}
      />
      <Route
        path="/check-in-v2/:checkInId/details"
        element={<CheckInV2DetailView />}
      />
    </Routes>
  );
};
